var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgBancoBrasil = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F9DC30"
  }), React.createElement("path", {
    d: "M13.9789 20.2951L11.9851 18.9638L20.9637 12.982L15.973 9.65669L13.4804 11.3222L15.4801 12.6421L10.9879 15.6387L7 12.9762L15.973 7L24.9516 12.9762L13.9789 20.2951Z",
    fill: "#1E447F"
  }), React.createElement("path", {
    d: "M10.9879 22.2891L8.99406 20.9579L7 22.2891V24.946L10.9879 22.2891Z",
    fill: "#1E447F"
  }), React.createElement("path", {
    d: "M22.9575 10.9879L20.9636 9.65669L24.9516 7V9.65669L22.9575 10.9879Z",
    fill: "#1E447F"
  }), React.createElement("path", {
    d: "M18.4712 20.6238L16.4716 19.2867L20.9579 16.2959L24.9516 18.9638L15.973 24.946L7 18.9638L17.9669 11.6508L19.9609 12.982L10.9879 18.9638L15.973 22.2891L18.4712 20.6238Z",
    fill: "#1E447F"
  }));
};
export default SvgBancoBrasil;